import React from 'react';
import '../styles/Article.css';

function Article({ title, date, content }) {
  return (
    <div className="article-container">
      <h1>{title || "Article Not Found"}</h1>
      <p className="article-date">{date ? new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }) : ""}</p>
      <div className="article-content">
        {content || <p>This article does not exist.</p>}
      </div>
    </div>
  );
}

export default Article; 